import keyMirror from 'keymirror';
import { FRONTEND_URL } from '../../../services/Constants';
import { IS_MOBILE_APP } from '../../../services/capacitor/Constants';
import { withLanguageLocale } from '../../../services/Helper';

export const lessonActionTypes = keyMirror({
	GET_LESSON_DETAILS_REQUEST: null,
	GET_LESSON_DETAILS_SUCCESS: null,
	GET_LESSON_DETAILS_ERROR: null,

	SEND_FEEDBACK_REQUEST: null,
	SEND_FEEDBACK_SUCCESS: null,
	SEND_FEEDBACK_ERROR: null,

	SHOW_SUCCESS_FEEDBACK: null,

	GET_SCHEDULED_LESSON_STUDENTS_REQUEST: null,
	GET_SCHEDULED_LESSON_STUDENTS_SUCCESS: null,
	GET_SCHEDULED_LESSON_STUDENTS_ERROR: null,

	MANAGE_STUDENT_STATUS_REQUEST: null,
	MANAGE_STUDENT_STATUS_SUCCESS: null,
	MANAGE_STUDENT_STATUS_ERROR: null,
});

export const getLiveLessonPath = (lessonId, userId, userName) =>
	(IS_MOBILE_APP ? FRONTEND_URL : '') + withLanguageLocale(`/lesson/attend/${lessonId}`);

export const LOG_TYPE = {
	LIVE_CLASS_CALL_JOINED: 'live_class_call_joined',
	LIVE_CLASS_CALL_LEFT: 'live_class_call_left',
	LIVE_CLASS_CONNECTION_STATUS_CHANGE: 'live_class_connection_status_change',
	LIVE_CLASS_READY: 'live_class_ready',
	LIVE_CLASS_CAMERA_TOGGLE: 'live_class_camera_toggle',
	LIVE_CLASS_SCREENSHARE_TOGGLE: 'live_class_screenshare_toggle',
	LIVE_CLASS_KNOCK: 'live_class_knock',
};

export const FEEDBACK_FORM = 'feedbackForm';
